import React from 'react';
import { Section } from './Section';
import { BookOpen, Brain, Wind, Calendar, ShieldAlert, RefreshCw } from 'lucide-react';
export function Deliverables() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-brand-blue" data-id="element-16" />,
    title: 'Manual Maestro Protocolo 22 (PDF)',
    desc: 'El paso a paso detallado del sistema ASC.'
  }, {
    icon: <Brain className="w-8 h-8 text-brand-blue" data-id="element-17" />,
    title: 'El Mapa de Zonificación Neural',
    desc: 'Identifica tus puntos de gatillo antes de que sea tarde.'
  }, {
    icon: <Wind className="w-8 h-8 text-brand-blue" data-id="element-18" />,
    title: 'Técnica de Respiración 4-4-8',
    desc: "El 'enfriamiento líquido' para tu sistema nervioso simpático."
  }, {
    icon: <Calendar className="w-8 h-8 text-brand-blue" data-id="element-19" />,
    title: 'Guía de Entrenamiento Individual de 22 Días',
    desc: 'Ejercicios diarios de 15 minutos en la privacidad de tu casa.'
  }, {
    icon: <ShieldAlert className="w-8 h-8 text-brand-blue" data-id="element-20" />,
    title: 'Protocolo de Emergencia (SOS)',
    desc: 'Qué hacer y qué decir si sientes que vas a fallar en medio del acto.'
  }, {
    icon: <RefreshCw className="w-8 h-8 text-brand-blue" data-id="element-21" />,
    title: 'Manual del Segundo Round',
    desc: 'Cómo recuperarse en tiempo récord para volver a la carga.'
  }];
  return <Section darker data-id="element-22">
      <h2 className="font-display font-bold text-3xl md:text-5xl mb-12 text-center uppercase tracking-tight" data-id="element-23">
        Lo que obtienes hoy
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-24">
        {items.map((item, index) => <div key={index} className="bg-brand-dark p-6 border border-brand-gray/30 hover:border-brand-blue/50 transition-colors" data-id="element-25">
            <div className="mb-4" data-id="element-26">{item.icon}</div>
            <h3 className="font-display font-bold text-xl mb-2 uppercase" data-id="element-27">
              {item.title}
            </h3>
            <p className="text-gray-400" data-id="element-28">{item.desc}</p>
          </div>)}
      </div>
    </Section>;
}